import { useEffect, useReducer } from "react";
import { reducer, actions, initialState } from "./reducer";
import { callApi } from "api";
export const useConfig = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    callApi(
      "/api/configurations/",
      "GET",
      {},
      {
        REQUEST: actions.GET_CONFIG_REQUEST,
        SUCCESS: actions.GET_CONFIG_SUCCESS,
        FAILURE: actions.GET_CONFIG_FAILURE,
      },
      dispatch,
      false
    );
  }, []);
  return [state.getConfig];
};
